import api from './apiClient';

export const meetingsAPI = {
  getMeetings: async (params?: { month?: string }): Promise<any> => {
    const response = await api.get('/meetings', { params });
    return response.data;
  },
  getMeeting: async (id: number): Promise<any> => {
    const response = await api.get(`/meetings/${id}`);
    return response.data;
  },
  createMeeting: async (data: any): Promise<any> => {
    // Mapowanie nazw pól z camelCase na snake_case dla kompatybilności z backendem
    const mappedData: any = {
      type: data.type,
      meeting_type: data.meetingType,
      title: data.title,
      description: data.description,
      location: data.location,
      project_id: data.projectId,
      owner_id: data.ownerId,
      call_id: data.callId,
      start_time: data.startTime,
      end_time: data.endTime,
      planned_minutes: data.plannedMinutes,
      actual_minutes: data.actualMinutes,
      participants: data.participants,
      channel: data.channel,
      source: data.source,
      funnel_stage: data.funnelStage,
      industry: data.industry,
      priority: data.priority,
      value_pln: data.valuePln,
      sentiment: data.sentiment,
      intent: data.intent,
      effectiveness_score: data.effectivenessScore,
      satisfaction_score: data.satisfactionScore,
      agenda: data.agenda,
      decisions: data.decisions,
      action_items: data.actionItems,
      status: data.status,
      outcome: data.outcome,
      loss_reason: data.lossReason,
      notes: data.notes,
      attachments: data.attachments,
      next_action: data.nextAction,
      next_due_at: data.nextDueAt,
      next_owner_id: data.nextOwnerId,
      follow_up_status: data.followUpStatus,
      reminders_enabled: data.remindersEnabled,
      tags: data.tags
    };

    const response = await api.post('/meetings', mappedData);
    return response.data;
  },
  updateMeeting: async (id: number, data: any): Promise<any> => {
    // Mapowanie nazw pól z camelCase na snake_case dla kompatybilności z backendem
    const mappedData: any = {};

    if (data.type !== undefined) mappedData.type = data.type;
    if (data.meetingType !== undefined) mappedData.meeting_type = data.meetingType;
    if (data.title !== undefined) mappedData.title = data.title;
    if (data.description !== undefined) mappedData.description = data.description;
    if (data.location !== undefined) mappedData.location = data.location;
    if (data.projectId !== undefined) mappedData.project_id = data.projectId;
    if (data.ownerId !== undefined) mappedData.owner_id = data.ownerId;
    if (data.callId !== undefined) mappedData.call_id = data.callId;
    if (data.startTime !== undefined) mappedData.start_time = data.startTime;
    if (data.endTime !== undefined) mappedData.end_time = data.endTime;
    if (data.plannedMinutes !== undefined) mappedData.planned_minutes = data.plannedMinutes;
    if (data.actualMinutes !== undefined) mappedData.actual_minutes = data.actualMinutes;
    if (data.participants !== undefined) mappedData.participants = data.participants;
    if (data.channel !== undefined) mappedData.channel = data.channel;
    if (data.source !== undefined) mappedData.source = data.source;
    if (data.funnelStage !== undefined) mappedData.funnel_stage = data.funnelStage;
    if (data.industry !== undefined) mappedData.industry = data.industry;
    if (data.priority !== undefined) mappedData.priority = data.priority;
    if (data.valuePln !== undefined) mappedData.value_pln = data.valuePln;
    if (data.sentiment !== undefined) mappedData.sentiment = data.sentiment;
    if (data.intent !== undefined) mappedData.intent = data.intent;
    if (data.effectivenessScore !== undefined) mappedData.effectiveness_score = data.effectivenessScore;
    if (data.satisfactionScore !== undefined) mappedData.satisfaction_score = data.satisfactionScore;
    if (data.agenda !== undefined) mappedData.agenda = data.agenda;
    if (data.decisions !== undefined) mappedData.decisions = data.decisions;
    if (data.actionItems !== undefined) mappedData.action_items = data.actionItems;
    if (data.status !== undefined) mappedData.status = data.status;
    if (data.outcome !== undefined) mappedData.outcome = data.outcome;
    if (data.lossReason !== undefined) mappedData.loss_reason = data.lossReason;
    if (data.notes !== undefined) mappedData.notes = data.notes;
    if (data.attachments !== undefined) mappedData.attachments = data.attachments;
    if (data.nextAction !== undefined) mappedData.next_action = data.nextAction;
    if (data.nextDueAt !== undefined) mappedData.next_due_at = data.nextDueAt;
    if (data.nextOwnerId !== undefined) mappedData.next_owner_id = data.nextOwnerId;
    if (data.followUpStatus !== undefined) mappedData.follow_up_status = data.followUpStatus;
    if (data.remindersEnabled !== undefined) mappedData.reminders_enabled = data.remindersEnabled;
    if (data.tags !== undefined) mappedData.tags = data.tags;

    const response = await api.put(`/meetings/${id}`, mappedData);
    return response.data;
  },
  deleteMeeting: async (id: number): Promise<any> => {
    const response = await api.delete(`/meetings/${id}`);
    return response.data;
  }
};

// Calls API
export const callsAPI = {
  getCalls: async (params?: { month?: string }): Promise<any> => {
    const response = await api.get('/calls', { params });
    return response.data;
  },
  getCall: async (id: number): Promise<any> => {
    const response = await api.get(`/calls/${id}`);
    return response.data;
  },
  createCall: async (data: any): Promise<any> => {
    const mappedData: any = {
      type: data.type,
      title: data.title,
      contact_name: data.contactName ?? data.contact_name,
      company: data.company,
      tax_id: data.taxId ?? data.tax_id,
      contact_phone: data.contactPhone ?? data.contact_phone,
      contact_email: data.contactEmail ?? data.contact_email,
      client_id: data.clientId ?? data.client_id,
      project_id: data.projectId ?? data.project_id,
      owner_id: data.ownerId ?? data.owner_id,
      planned_at: data.plannedAt ?? data.planned_at ?? data.scheduledTime ?? data.scheduled_time,
      planned_minutes: data.plannedMinutes ?? data.planned_minutes ?? data.durationMinutes ?? data.duration_minutes,
      started_at: data.startedAt ?? data.started_at,
      actual_minutes: data.actualMinutes ?? data.actual_minutes,
      sla_bucket: data.slaBucket ?? data.sla_bucket,
      channel: data.channel,
      source: data.source,
      funnel_stage: data.funnelStage ?? data.funnel_stage,
      industry: data.industry,
      priority: data.priority,
      value_pln: data.valuePln ?? data.value_pln,
      sentiment: data.sentiment,
      intent: data.intent,
      status: data.status,
      outcome: data.outcome ?? data.outcome,
      loss_reason: data.lossReason ?? data.loss_reason,
      notes: data.notes,
      next_action: data.nextAction ?? data.next_action,
      next_due_at: data.nextDueAt ?? data.next_due_at,
      next_owner_id: data.nextOwnerId ?? data.next_owner_id,
      reminders_enabled: data.remindersEnabled ?? data.reminders_enabled,
      consent: data.consent,
      contact_prefs: data.contactPrefs ?? data.contact_prefs,
      tags: data.tags
    };

    const response = await api.post('/calls', mappedData);
    return response.data;
  },
  updateCall: async (id: number, data: any): Promise<any> => {
    const mappedData: any = {};

    if (data.type !== undefined) mappedData.type = data.type;
    if (data.title !== undefined) mappedData.title = data.title;
    if (data.contactName !== undefined) mappedData.contact_name = data.contactName;
    if (data.company !== undefined) mappedData.company = data.company;
    if (data.taxId !== undefined) mappedData.tax_id = data.taxId;
    if (data.contactPhone !== undefined) mappedData.contact_phone = data.contactPhone;
    if (data.contactEmail !== undefined) mappedData.contact_email = data.contactEmail;
    if (data.clientId !== undefined) mappedData.client_id = data.clientId;
    if (data.projectId !== undefined) mappedData.project_id = data.projectId;
    if (data.ownerId !== undefined) mappedData.owner_id = data.ownerId;
    if (data.plannedAt !== undefined) mappedData.planned_at = data.plannedAt;
    if (data.scheduledTime !== undefined) mappedData.planned_at = data.scheduledTime;
    if (data.plannedMinutes !== undefined) mappedData.planned_minutes = data.plannedMinutes;
    if (data.durationMinutes !== undefined) mappedData.planned_minutes = data.durationMinutes;
    if (data.startedAt !== undefined) mappedData.started_at = data.startedAt;
    if (data.actualMinutes !== undefined) mappedData.actual_minutes = data.actualMinutes;
    if (data.slaBucket !== undefined) mappedData.sla_bucket = data.slaBucket;
    if (data.channel !== undefined) mappedData.channel = data.channel;
    if (data.source !== undefined) mappedData.source = data.source;
    if (data.funnelStage !== undefined) mappedData.funnel_stage = data.funnelStage;
    if (data.industry !== undefined) mappedData.industry = data.industry;
    if (data.priority !== undefined) mappedData.priority = data.priority;
    if (data.valuePln !== undefined) mappedData.value_pln = data.valuePln;
    if (data.sentiment !== undefined) mappedData.sentiment = data.sentiment;
    if (data.intent !== undefined) mappedData.intent = data.intent;
    if (data.status !== undefined) mappedData.status = data.status;
    if (data.outcome !== undefined) mappedData.outcome = data.outcome;
    if (data.lossReason !== undefined) mappedData.loss_reason = data.lossReason;
    if (data.notes !== undefined) mappedData.notes = data.notes;
    if (data.nextAction !== undefined) mappedData.next_action = data.nextAction;
    if (data.nextDueAt !== undefined) mappedData.next_due_at = data.nextDueAt;
    if (data.nextOwnerId !== undefined) mappedData.next_owner_id = data.nextOwnerId;
    if (data.remindersEnabled !== undefined) mappedData.reminders_enabled = data.remindersEnabled;
    if (data.consent !== undefined) mappedData.consent = data.consent;
    if (data.contactPrefs !== undefined) mappedData.contact_prefs = data.contactPrefs;
    if (data.tags !== undefined) mappedData.tags = data.tags;

    const response = await api.put(`/calls/${id}`, mappedData);
    return response.data;
  },
  deleteCall: async (id: number): Promise<any> => {
    const response = await api.delete(`/calls/${id}`);
    return response.data;
  }
};
